import React, { useEffect, useState } from 'react'
import PaymentMethodInfo from './components/PaymentMethodInfo'
import PaymentMethodSelection from './components/PaymentMethodSelection'
import PaymentDetails from './components/PaymentDetails'
import SecurityProtection from '../deposit/components/SecurityProtection'
import WithdrawRequest from './WithdrawRequest';

import toast from 'react-hot-toast'
import { YourWallet } from '../../../../api/request/dashboard'
import { useSelector } from 'react-redux'
import { GetWalletApi } from '../../../../api/request/transfer'
import { Spin } from 'antd'
import { handleApiError } from '../../../../utils/handleApiError'

const Withdraw3 = () => {
    const { userDetails } = useSelector((state) => state.user);
    const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(null);
    const [isRefresh, setIsRefresh] = useState(false);
    const [showPaymentDetails, setShowPaymentDetails] = useState(false);
    const [withdrawAmount, setWithdrawAmount] = useState(0);
    const [walletBalance, setWalletBalance] = useState(0)
    const [isLoading, setIsLoading] = useState(false)
    const [paymentMethodData, setPaymentMethodData] = useState({ processingTime: '24 H', minAmount: 0, maxAmount: 0 })

    const handlePaymentMethodSelect = (method) => {
        setSelectedPaymentMethod(method);
    };

    const handleWithdrawClick = (amount) => {
        setWithdrawAmount(amount);
        setShowPaymentDetails(true);
    };

    const handleBackToSelection = () => {
        setShowPaymentDetails(false);
    };

    const handleSecureWithdraw = (formData) => {
    };

    const getWalletBalance = async () => {
        try {
            const { data } = await YourWallet(userDetails?._id);
            if (data?.success) {
                setWalletBalance(data?.data?.walletAmount);
            }
        } catch (error) {
            handleApiError(error);
        }
    }

    const getWalletDetails = async () => {
        try {
            setIsLoading(true);
            const params = { RuleType: 'Withdraw' }
            const { data } = await GetWalletApi(userDetails?._id, new URLSearchParams(params).toString());
            if (data?.success) {
                setPaymentMethodData({ minAmount: data?.data?.minAmount, maxAmount: data?.data?.maxAmount })
                setIsLoading(false);
            }
        } catch (error) { setIsLoading(false) }
    }

    useEffect(() => {
        getWalletBalance();
        getWalletDetails();
    }, [])

    return (
        <div className="min-h-screen py-3">
            {isLoading ? <div className="flex h-screen justify-center items-center py-20">
                <Spin size="large" />
            </div> :
                <>
                    {/* Payment Method Info - Always visible with wallet details */}
                    <div className="mt-3">
                        <PaymentMethodInfo paymentMethod={paymentMethodData} walletBalance={walletBalance} isLoading={isLoading} selectedMethod={selectedPaymentMethod} />
                    </div>

                    {/* Payment Method Selection */}
                    {!showPaymentDetails ? <PaymentMethodSelection
                        onMethodSelect={handlePaymentMethodSelect}
                        selectedMethod={selectedPaymentMethod}
                        onWithdrawClick={handleWithdrawClick}
                        paymentMethod={paymentMethodData}

                    /> :
                        <PaymentDetails
                            amount={withdrawAmount}
                            paymentMethod={selectedPaymentMethod}
                            onBack={handleBackToSelection}
                            onSecureWithdraw={handleSecureWithdraw}
                            walletBalance={walletBalance}
                            resetAll={() => {
                                setShowPaymentDetails(false);
                                setSelectedPaymentMethod(null);
                                setWithdrawAmount(0);
                            }}
                        />
                    }

                    {/* Security & Protection Section */}
                    <SecurityProtection />

                    <div className=' p-6 border-2 border-light rounded-md mt-3'>
                        <WithdrawRequest
                            isRefresh={isRefresh}
                            setIsRefresh={setIsRefresh}
                            onWithdrawClick={handleWithdrawClick}
                        />
                    </div>
                </>}
        </div>
    )
}

export default Withdraw3